export default __webpack_public_path__ + "maps-examples-approximate-location-1200-b9100c439dfcfd152032f5a9bb48e950.png";